function applyPurchaseOptionMedia(source) {
    let state;

    if (source && source.name === 'purchase_option' && source.checked) {
        state = source.value;
    } else {
        const subscriptionRadio = document.querySelector('input[name="purchase_option"][value="abonnement"]');
        state = subscriptionRadio && subscriptionRadio.checked ? 'abonnement' : 'once';
    }

    document.body.dataset.purchaseOption = state;

    const groups = new Map();
    document.querySelectorAll('[data-purchase-media][data-purchase-media-group]').forEach(element => {
        const key = element.dataset.purchaseMediaGroup;
        if (!groups.has(key)) groups.set(key, []);
        groups.get(key).push(element);
    });

    const revealed = [];

    groups.forEach(elements => {
        const hasMatch = elements.some(element => element.dataset.purchaseMedia === state);

        elements.forEach(element => {
            const shouldShow = hasMatch
                ? element.dataset.purchaseMedia === state
                : element.dataset.purchaseMedia === 'once';
            const wasHidden = element.hidden;

            element.hidden = !shouldShow;

            if (wasHidden && shouldShow) revealed.push(element);
        });
    });

    if (typeof window.initializeSplideMedia !== 'function') return;

    revealed.forEach(element => {
        const slider = element.matches('.mm-product-medias-main-splide')
            ? element
            : element.querySelector('.mm-product-medias-main-splide');
        if (slider) window.initializeSplideMedia(slider);
    });
}

window.applyPurchaseOptionMedia = applyPurchaseOptionMedia;

document.addEventListener('change', (event) => {
    if (event.target && event.target.name === 'purchase_option') {
        applyPurchaseOptionMedia(event.target);
        applyPurchaseOptionVariant(event.target.closest('form'));
    }
});

function isSubscriptionSelected(form) {
    const scopedRadio = form && form.querySelector('input[name="purchase_option"][value="abonnement"]');
    const radio = scopedRadio || document.querySelector('input[name="purchase_option"][value="abonnement"]');
    return radio ? radio.checked : false;
}

function applyPurchaseOptionVariant(form) {
    if (!form) return;

    const variantInput = form.querySelector('input[name="id"]');
    if (!variantInput) return;

    const onceId = form.dataset.variantOnce;
    const aboId = form.dataset.variantAbo;
    const isSubscription = isSubscriptionSelected(form);

    if (onceId && aboId) {
        variantInput.value = isSubscription ? aboId : onceId;
    }

    form.querySelectorAll('[data-selling-plan]').forEach(field => {
        if (isSubscription && field.tagName === 'INPUT' && !field.value) {
            field.value = form.dataset.sellingPlanAbo || '';
        }
        field.disabled = !isSubscription;
    });
}

window.applyPurchaseOptionVariant = applyPurchaseOptionVariant;

function initializeSubscription() {
    const forms = document.querySelectorAll('form[data-type="add-to-cart-form"]');
    const purchaseOptionInputs = document.querySelectorAll('[data-purchase-option]');
    const sellingPlanSelects = document.querySelectorAll('[data-selling-plan]');

    function syncPurchaseOptions(currentInput) {
        if (!currentInput || currentInput.name !== 'purchase_option') return;
        if (!currentInput.checked) return;

        const value = currentInput.value;
        document.querySelectorAll('input[name="purchase_option"]').forEach(radio => {
            if (radio === currentInput) return;
            radio.checked = radio.value === value;
        });
    }

    function syncSellingPlans(currentSelect) {
        const value = currentSelect.value;
        sellingPlanSelects.forEach(select => {
            if (select !== currentSelect) {
                select.value = value;
            }
        });
    }

    function updateCTAPrice(form) {
        const nextPrices = form.querySelector('template[data-cta-price="' + (isSubscriptionSelected(form) ? 'abonnement' : 'once') + '"]')?.content.querySelector('.mm-buy-button-prices');
        const currentPrices = form.querySelector('button[type="submit"] .mm-buy-button-prices');
        if (nextPrices && currentPrices) {
            currentPrices.replaceWith(nextPrices.cloneNode(true));
            return;
        }

        const ctaPriceElement = form.querySelector('.mm-buy-button-prices .mm-product-price');
        const ctaComparePriceElement = form.querySelector('.mm-buy-button-prices .mm-product-compare-at-price');

        if (!ctaPriceElement) return;

        let priceValue = 0;
        let comparePriceValue = 0;
        const currencySymbol = document.body.dataset.currency || '€';

        const isSubscription = isSubscriptionSelected(form);
        const scope = isSubscription ? '.mm-product-form-recharge-abonnement' : '.mm-product-form-recharge-once';
        const scopedPriceElement = form.querySelector(scope + ' .mm-product-price');
        const scopedComparePriceElement = form.querySelector(scope + ' .mm-product-compare-at-price');

        if (scopedPriceElement) {
            priceValue = parseFloat(scopedPriceElement.dataset.price);
            if (scopedComparePriceElement) comparePriceValue = parseFloat(scopedComparePriceElement.dataset.comparePrice);
        } else {
            priceValue = parseFloat(isSubscription ? form.dataset.priceAbo : form.dataset.priceOnce) || 0;
            comparePriceValue = parseFloat(isSubscription ? form.dataset.compareAbo : form.dataset.compareOnce) || 0;
        }

        function formatNumber(value) { return Number.isInteger(value) ? value : value.toFixed(2); }
        function formatPrice(symbol, value) {
            const formattedValue = formatNumber(value);
            return (symbol === "£" || symbol === "$") ? (symbol + formattedValue) : (formattedValue + symbol);
        }

        if (priceValue > 0) {
            const total = priceValue / 100;
            ctaPriceElement.innerHTML = formatPrice(currencySymbol, total);
            ctaPriceElement.dataset.price = priceValue;
        }

        if (comparePriceValue > 0 && priceValue < comparePriceValue) {
            if (!ctaComparePriceElement) {
                const newComparePriceElement = document.createElement('p');
                newComparePriceElement.className = 'mm-product-compare-at-price mm-linethrough overtitre mm-black-400';
                newComparePriceElement.setAttribute('data-compare-price', comparePriceValue);
                newComparePriceElement.setAttribute('aria-label', 'Prix original');
                ctaPriceElement.parentElement.insertBefore(newComparePriceElement, ctaPriceElement);
                const total = comparePriceValue / 100;
                newComparePriceElement.innerHTML = formatPrice(currencySymbol, total);
            } else {
                const total = comparePriceValue / 100;
                ctaComparePriceElement.innerHTML = formatPrice(currencySymbol, total);
                ctaComparePriceElement.dataset.comparePrice = comparePriceValue;
            }
        } else if (ctaComparePriceElement && comparePriceValue <= 0) {
            ctaComparePriceElement.remove();
        }
    }

    purchaseOptionInputs.forEach(input => {
        if (input.dataset.mmSubBound) return;
        input.dataset.mmSubBound = 'true';
        input.addEventListener('change', (e) => {
            syncPurchaseOptions(e.target);
            document.querySelectorAll('form[data-type="add-to-cart-form"]').forEach(form => {
                const oneTimeRadio = form.querySelector('input[name="purchase_option"][value="once"]');
                const sellingPlanSelect = form.querySelector('select[name="selling_plan"]');
                if (oneTimeRadio && sellingPlanSelect) {
                    sellingPlanSelect.disabled = oneTimeRadio.checked;
                }
                applyPurchaseOptionVariant(form);
                updateCTAPrice(form);
            });
            applyPurchaseOptionMedia();
        });
    });

    sellingPlanSelects.forEach(select => {
        if (select.dataset.mmSubBound) return;
        select.dataset.mmSubBound = 'true';
        select.addEventListener('change', (e) => {
            syncSellingPlans(e.target);
        });
    });

    forms.forEach(form => {
        const oneTimeRadio = form.querySelector('input[name="purchase_option"][value="once"]');
        const subscriptionRadio = form.querySelector('input[name="purchase_option"][value="abonnement"]');
        const sellingPlanSelect = form.querySelector('select[name="selling_plan"]');
        const productContainer = form.closest('.mm-main-product-container');

        if (!productContainer) return;

        const loyaltyContainer = productContainer.querySelector('.mm-product-form-buy-button-infos-fidelite');

        if (!oneTimeRadio || !subscriptionRadio || !sellingPlanSelect) return;

        function updateLoyaltyPoints() {
            if (!loyaltyContainer) return;

            const loyaltyRate = parseFloat(loyaltyContainer.dataset.loyaltyRate) || 0;
            const textTemplate = loyaltyContainer.dataset.loyaltyTextTemplate || '';
            const loyaltyLabel = loyaltyContainer.querySelector('.mm-label');
            let price = 0;

            if (oneTimeRadio.checked) {
                const priceElement = form.querySelector('.mm-product-form-recharge-once .mm-product-price');
                if (priceElement) price = parseFloat(priceElement.dataset.price) / 100;
            } else {
                const priceElement = form.querySelector('.mm-product-form-recharge-abonnement .mm-product-price');
                if (priceElement) price = parseFloat(priceElement.dataset.price) / 100;
            }

            const points = Math.round(price * loyaltyRate);
            if (loyaltyLabel && textTemplate) {
                loyaltyLabel.textContent = textTemplate.replace('[points]', points);
            }
        }

        function updateState() {
            sellingPlanSelect.disabled = oneTimeRadio.checked;
            updateLoyaltyPoints();
            updateCTAPrice(form);
            applyPurchaseOptionMedia();
        }

        if (!oneTimeRadio.dataset.mmSubStateBound) {
            oneTimeRadio.dataset.mmSubStateBound = 'true';
            oneTimeRadio.addEventListener('change', updateState);
        }
        if (!subscriptionRadio.dataset.mmSubStateBound) {
            subscriptionRadio.dataset.mmSubStateBound = 'true';
            subscriptionRadio.addEventListener('change', updateState);
        }

        updateState();
    });

    forms.forEach(form => {
        applyPurchaseOptionVariant(form);
        updateCTAPrice(form);
    });
    applyPurchaseOptionMedia();
}

document.addEventListener('DOMContentLoaded', initializeSubscription);
document.addEventListener('shopify:section:load', initializeSubscription);
